import DOMPurify from 'dompurify';

const RICH_TEXT_ALLOWED_TAGS = [
  'p',
  'br',
  'ul',
  'ol',
  'li',
  'blockquote',
  'strong',
  'em',
  'u',
  's',
  'b',
  'i',
  'span',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'a',
];

export const RICH_TEXT_ALLOWED_ATTRIBUTES = [
  'href',
  'title',
  'data-mention-id',
  'data-mention-trigger',
];

export const sanitizeRichText = (html: unknown = ''): string => {
  const sanitizedHtml = typeof html === 'string' ? html : '';
  return DOMPurify.sanitize(sanitizedHtml, {
    ALLOWED_ATTR: RICH_TEXT_ALLOWED_ATTRIBUTES,
    ALLOWED_TAGS: RICH_TEXT_ALLOWED_TAGS,
  });
};

export const stripHtml = (html: string = ''): string => {
  const element = document.createElement('div');
  element.innerHTML = html;
  return (element.textContent || '').replace(/\s+/g, ' ').trim();
};
